import clsx from "clsx";
import styles from "./grid-empty-message.module.scss";
import { GridEmptyMessageProps } from "./@types/gridEmptyMessageProps";

const GridEmptyMessage = ({
  message,
  styleVariant = "default"
}: GridEmptyMessageProps) => {
  const containerClassName = clsx(
    styles["gridEmptyMessageComponent"],
    styles[`grid-empty-message-${styleVariant}`]
  );

  return (
    <div className={containerClassName}>
      <div className={styles["grid-empty-message-content"]}>{message}</div>
    </div>
  );
};

export default GridEmptyMessage;
